import React, { useEffect, useState } from "react";
import "../../css/ProductAddPage.css";
import AdminHeader from "../../components/header/AdminHeader";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-hot-toast";
import axios from "axios";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

function ProductUpdatePage() {
  const navigate = useNavigate();
  const params = useParams();
  const apiUrl = `${process.env.REACT_APP_API}`;

  const [productName, setProductName] = useState("");
  const [productPrice, setProductPrice] = useState("");
  const [salePrice, setSalePrice] = useState("");
  const [productSize, setProductSize] = useState({
    sizes: [{ label: "", quantity: "" }],
  });
  const [productDescription, setProductDescription] = useState("");
  const [productCategory, setProductCategory] = useState("");

  const [frontImageFile, setFrontImageFile] = useState(null);
  const [rightImageFile, setRightImageFile] = useState(null);
  const [leftImageFile, setLeftImageFile] = useState(null);
  const [backImageFile, setBackImageFile] = useState(null);
  const [frontImage, setFrontImage] = useState("");
  const [rightImage, setRightImage] = useState("");
  const [leftImage, setLeftImage] = useState("");
  const [backImage, setBackImage] = useState("");
  const [featured, setFeatured] = useState("");
  const [productId, setProductId] = useState("");
  const [isLoading, setIsLoading] = useState(true);

  // AI Image Generation States
  const [isGeneratingAI, setIsGeneratingAI] = useState(false);
  const [aiGeneratedPreview, setAiGeneratedPreview] = useState(null);
  const [useAIImage, setUseAIImage] = useState(false);

  // Video generation states
  const [isGeneratingVideo, setIsGeneratingVideo] = useState(false);
  const [productVideoUrl, setProductVideoUrl] = useState(""); // update existing one if already added


  const [formErrors, setFormErrors] = useState({});

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, []);

  const onFileChange1 = (e) => {
    const file = e.target.files[0];
    if (file) {
      setFrontImageFile(file);
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onloadend = () => {
        setFrontImageFile(file);
        setFrontImage(reader.result);
        // Reset AI image when new file is uploaded
        setAiGeneratedPreview(null);
        setUseAIImage(false);
      };
    } else {
      setFrontImageFile(null);
      setFrontImage("");
    }
  };

  const onFileChange2 = (e) => {
    const file = e.target.files[0];
    if (file) {
      setLeftImageFile(file);
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onloadend = () => {
        setLeftImageFile(file);
        setLeftImage(reader.result);
      };
    } else {
      setLeftImageFile(null);
      setLeftImage("");
    }
  };

  const onFileChange3 = (e) => {
    const file = e.target.files[0];
    if (file) {
      setRightImageFile(file);
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onloadend = () => {
        setRightImageFile(file);
        setRightImage(reader.result);
      };
    } else {
      setRightImageFile(null);
      setRightImage("");
    }
  };

  const onFileChange4 = (e) => {
    const file = e.target.files[0];
    if (file) {
      setBackImageFile(file);
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onloadend = () => {
        setBackImageFile(file);
        setBackImage(reader.result);
      };
    } else {
      setBackImageFile(null);
      setBackImage("");
    }
  };

  // NEW: Delete image functions
  const deleteFrontImage = () => {
    setFrontImage("");
    setFrontImageFile(null);
    setAiGeneratedPreview(null);
    setUseAIImage(false);
  };

  const deleteLeftImage = () => {
    setLeftImage("");
    setLeftImageFile(null);
  };

  const deleteRightImage = () => {
    setRightImage("");
    setRightImageFile(null);
  };

  const deleteBackImage = () => {
    setBackImage("");
    setBackImageFile(null);
  };

  const onSizeChange = (event, index) => {
    const { name, value } = event.target;
    const sizes = [...productSize.sizes];
    sizes[index][name] = value;
    setProductSize({
      ...productSize,
      sizes,
    });
  };

  const handleAddSize = () => {
    setProductSize({
      ...productSize,
      sizes: [...productSize.sizes, { label: "", quantity: "" }],
    });
  };

  const handleRemoveSize = () => {
    const newSizes = [...productSize.sizes];
    newSizes.pop();
    setProductSize({ ...productSize, sizes: newSizes });
  };

  useEffect(() => {
    getProduct();
  }, []);

  const getProduct = async () => {
    try {
      setIsLoading(true);
      const res = await fetch(`${apiUrl}/product/${params.productId}`, {
        method: "GET",
      });
      const data = await res.json();
      setProductName(data.productName);
      setProductDescription(data.productDescription);
      setProductSize(data.productSize);
      setFeatured(data.isFeatured);
      setProductPrice(data.productPrice);
      setSalePrice(data.salePrice);
      setProductId(data._id);

      // FIXED: Extract category ID if it's an object
      if (data.productCategory) {
        setProductCategory(data.productCategory._id || data.productCategory);
      }

      // Set images
      setFrontImage(data.images.front);
      setBackImage(data.images.back);
      setLeftImage(data.images.left);
      setRightImage(data.images.right);

      setProductVideoUrl(data.videoUrl || ""); // ADD THIS

      setIsLoading(false);
    } catch (err) {
      console.log(err);
      toast.error("Error loading product");
      setIsLoading(false);
    }
  };

  // Generate AI Model Image (using URL directly)
  const handleGenerateAIImage = async () => {
    if (!frontImageFile && !frontImage) {
      toast.error("Please upload a front image first");
      return;
    }

    setIsGeneratingAI(true);

    try {
      console.log("🚀 Starting AI image generation...");

      const formData = new FormData();

      // If user uploaded a new image, send the file; otherwise send the URL
      if (frontImageFile) {
        console.log("Using newly uploaded file");
        formData.append("flatLayImage", frontImageFile);
      } else {
        console.log("Using existing image URL:", frontImage);
        formData.append("imageUrl", frontImage);
      }

      formData.append("productName", productName);
      formData.append("productCategory", productCategory);

      console.log("📤 Sending request to generate AI image...");

      const response = await axios.post(
          `${apiUrl}/generate-model-preview`,
          formData,
          {
            headers: { "Content-Type": "multipart/form-data" },
            timeout: 120000,
          }
      );

      console.log("✅ Response received:", response.data);

      if (response.data.success && response.data.previewUrl) {
        setAiGeneratedPreview(response.data.previewUrl);
        toast.success("AI model image generated successfully!");
        console.log("🎉 AI image URL:", response.data.previewUrl);
      } else {
        toast.error("Unexpected response from server");
      }

      setIsGeneratingAI(false);
    } catch (error) {
      console.error("❌ Error generating AI image:", error);
      setIsGeneratingAI(false);

      const errorMessage =
          (error.response && error.response.data && error.response.data.message) ||
          error.message ||
          "Failed to generate AI image";
      toast.error(errorMessage);
    }
  };

  // Approve AI Image
  const handleApproveAIImage = () => {
    setUseAIImage(true);
    setFrontImage(aiGeneratedPreview);
    toast.success("AI image approved! It will be used as the front image.");
  };

  // Reject AI Image
  const handleRejectAIImage = () => {
    setAiGeneratedPreview(null);
    setUseAIImage(false);
    toast("AI image removed.");
  };

  const validateForm = () => {
    let errors = {};

    if (!productName.trim()) {
      errors.productName = "Name is required";
    } else if (productName.length < 3 || productName.length > 50) {
      errors.productName = "Name must be between 3 and 50 characters";
    }

    if (!productPrice) {
      errors.productPrice = "Price is required";
    } else if (!/^\d+(\.\d{1,2})?$/.test(productPrice)) {
      errors.productPrice = "Price must be a valid number";
    } else if (isNaN(productPrice) || productPrice <= 0) {
      errors.productPrice = "Please enter a valid price";
    }

    setFormErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const updateProduct = async (e) => {
    e.preventDefault();

    if (validateForm()) {
      const formData = new FormData();
      formData.append("productName", productName);
      formData.append("productPrice", productPrice);
      if (salePrice) {
        formData.append("salePrice", salePrice);
      }
      formData.append("productSize", JSON.stringify(productSize));
      if (productDescription) {
        formData.append("productDescription", productDescription);
      }
      if (featured) {
        formData.append("isFeatured", featured);
      }

      // Handle front image
      if (useAIImage && aiGeneratedPreview) {
        console.log("Using AI image URL directly:", aiGeneratedPreview);
        formData.append("aiImageUrl", aiGeneratedPreview);
      } else if (frontImageFile) {
        formData.append("front", frontImageFile);
        console.log("Uploading new front image file");
      } else if (!frontImage) {
        formData.append("front", "");
      }

      // Handle left image
      if (leftImageFile) {
        formData.append("left", leftImageFile);
      } else if (!leftImage) {
        formData.append("left", "");
      }

      // Handle right image
      if (rightImageFile) {
        formData.append("right", rightImageFile);
      } else if (!rightImage) {
        formData.append("right", "");
      }

      // Handle back image
      if (backImageFile) {
        formData.append("back", backImageFile);
      } else if (!backImage) {
        formData.append("back", "");
      }
      // Send video URL if available
      if (productVideoUrl) {
        formData.append("videoUrl", productVideoUrl);
      }

      try {
        console.log("Submitting product update...");

        const res2 = await axios.put(
            `${apiUrl}/product/${productId}`,
            formData,
            {
              headers: {
                "Content-Type": "multipart/form-data",
              },
            }
        );

        console.log("Update response:", res2.data);
        toast.success("Product Updated Successfully!");

        const tempScroll = sessionStorage.getItem('productPageScrollTemp');
        const tempCount = sessionStorage.getItem('productDisplayCountTemp');

        if (tempScroll) {
          sessionStorage.setItem('productPageScroll', tempScroll);
        }
        if (tempCount) {
          sessionStorage.setItem('productDisplayCount', tempCount);
        }

        navigate(-1);
      } catch (error) {
        console.error("Error updating product:", error);
        console.error("Error response:", error.response);
        toast.error("Error updating product: " + ((error.response && error.response.data && error.response.data.message) || error.message));
      }
    }
  };


  const improveDescription = () => {
    axios
        .post(`${apiUrl}/improve-description`, {
          productDescription: productDescription,
        })
        .then((response) => {
          setProductDescription(response.data.improvedDescription);
          toast.success("Description improved!");
        })
        .catch((error) => {
          console.error("Error improving description:", error);
          toast.error("Error improving description");
        });
  };

  const handleBack = () => {
    navigate(-1);
  };

  if (isLoading) {
    return (
        <>
          <AdminHeader />
          <div className="container pt-5 mt-5 text-center">
            <div className="spinner-border text-primary" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
            <p className="mt-2">Loading product...</p>
          </div>
        </>
    );
  }

  const handleGenerateVideo = async () => {
    const imageToUse = useAIImage ? aiGeneratedPreview : frontImage;

    if (!imageToUse) {
      toast.error("Please upload or generate a front image first");
      return;
    }

    setIsGeneratingVideo(true);

    try {
      toast("🎬 Video generation started, we'll notify you when done...", {
        duration: 5000,
      });

      // Step 1: Start job
      const response = await axios.post(
          `${apiUrl}/generate-video-preview`,
          { imageUrl: imageToUse },
          { timeout: 15000 }
      );

      const { jobId } = response.data;
      console.log("🎬 Job started:", jobId);

      // Step 2: Poll for completion
      let finished = false;
      const pollInterval = setInterval(async () => {
        try {
          const statusRes = await axios.get(`${apiUrl}/video-job-status/${jobId}`);
          const { status, videoUrl, error } = statusRes.data;

          console.log("⏳ Job status:", status);

          if (status === "completed" && videoUrl) {
            finished = true;
            clearInterval(pollInterval);
            setProductVideoUrl(videoUrl);
            setIsGeneratingVideo(false);
            toast.success("🎬 Video generated successfully!");
          } else if (status === "failed") {
            finished = true;
            clearInterval(pollInterval);
            setIsGeneratingVideo(false);
            toast.error(error || "Video generation failed");
          }
        } catch (pollError) {
          console.error("Poll error:", pollError);
        }
      }, 5000);

      // Renders take 5-8 minutes; the server gives up at 15, so wait a touch longer.
      setTimeout(() => {
        if (finished) return;
        clearInterval(pollInterval);
        setIsGeneratingVideo(false);
        toast.error("The video is taking longer than expected. Please try again in a few minutes.");
      }, 16 * 60 * 1000);

    } catch (error) {
      setIsGeneratingVideo(false);
      toast.error(error.message || "Failed to start video generation");
    }
  };

  return (
      <>
        <AdminHeader />
        <div className="container pt-5">
          <div className="mt-5 pt-3">
            <button
                onClick={handleBack}
                className="btn btn-outline-secondary mb-3"
            >
              <ArrowBackIcon fontSize="small" /> Back to Products
            </button>

            <div className="card shadow-lg p-4">
              <h1 className="text-center mb-4">Edit Product</h1>

              <div className="alert alert-info">
                <strong>Editing:</strong> {productName}
              </div>

              <form onSubmit={updateProduct} encType="multipart/form-data">
                {/* Basic Information Section */}
                <div className="mb-4">
                  <h4 className="border-bottom pb-2 mb-3">Basic Information</h4>

                  <div className="row mb-3">
                    <label htmlFor="productName" className="col-sm-3 col-form-label fw-bold">
                      Product Name *
                    </label>
                    <div className="col-sm-9">
                      <input
                          type="text"
                          className={`form-control ${formErrors.productName ? 'is-invalid' : ''}`}
                          id="productName"
                          value={productName}
                          onChange={(event) => setProductName(event.target.value)}
                      />
                      {formErrors.productName && (
                          <div className="invalid-feedback">{formErrors.productName}</div>
                      )}
                    </div>
                  </div>

                  <div className="row mb-3">
                    <label htmlFor="productPrice" className="col-sm-3 col-form-label fw-bold">
                      Price *
                    </label>
                    <div className="col-sm-4">
                      <div className="input-group">
                        <span className="input-group-text">$</span>
                        <input
                            type="text"
                            className={`form-control ${formErrors.productPrice ? 'is-invalid' : ''}`}
                            id="productPrice"
                            value={productPrice}
                            onChange={(event) => setProductPrice(event.target.value)}
                        />
                        {formErrors.productPrice && (
                            <div className="invalid-feedback">{formErrors.productPrice}</div>
                        )}
                      </div>
                    </div>

                    <label htmlFor="salePrice" className="col-sm-2 col-form-label fw-bold">
                      Sale Price
                    </label>
                    <div className="col-sm-3">
                      <div className="input-group">
                        <span className="input-group-text">$</span>
                        <input
                            type="text"
                            className="form-control"
                            id="salePrice"
                            value={salePrice}
                            onChange={(event) => setSalePrice(event.target.value)}
                        />
                      </div>
                    </div>
                  </div>

                  <div className="row mb-3">
                    <label htmlFor="featured" className="col-sm-3 col-form-label fw-bold">
                      Featured Product
                    </label>
                    <div className="col-sm-9">
                      <div className="form-check form-check-inline">
                        <input
                            className="form-check-input"
                            type="radio"
                            name="featured"
                            id="featuredYes"
                            value="yes"
                            checked={featured === true}
                            onChange={(event) => setFeatured(event.target.value)}
                        />
                        <label className="form-check-label" htmlFor="featuredYes">
                          Yes
                        </label>
                      </div>
                      <div className="form-check form-check-inline">
                        <input
                            className="form-check-input"
                            type="radio"
                            name="featured"
                            id="featuredNo"
                            value="no"
                            checked={featured === false}
                            onChange={(event) => setFeatured(event.target.value)}
                        />
                        <label className="form-check-label" htmlFor="featuredNo">
                          No
                        </label>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Sizes Section */}
                <div className="mb-4">
                  <h4 className="border-bottom pb-2 mb-3">Sizes & Inventory</h4>

                  <div className="row mb-3">
                    <div className="col-sm-12">
                      <div className="row g-2">
                        {productSize.sizes.map((size, index) => (
                            <div key={index} className="col-md-6 col-lg-4">
                              <div className="card p-2">
                                <div className="row g-2">
                                  <div className="col-6">
                                    <label className="form-label small">Size</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="e.g., S, M, L"
                                        name="label"
                                        value={size.label}
                                        onChange={(e) => onSizeChange(e, index)}
                                    />
                                  </div>
                                  <div className="col-6">
                                    <label className="form-label small">Quantity</label>
                                    <input
                                        type="number"
                                        className="form-control"
                                        placeholder="Qty"
                                        name="quantity"
                                        value={size.quantity}
                                        onChange={(e) => onSizeChange(e, index)}
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                        ))}
                      </div>
                      <div className="mt-3">
                        <button
                            type="button"
                            className="btn btn-outline-primary btn-sm me-2"
                            onClick={handleAddSize}
                        >
                          + Add Size
                        </button>
                        <button
                            type="button"
                            className="btn btn-outline-danger btn-sm"
                            onClick={handleRemoveSize}
                        >
                          - Remove Size
                        </button>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Description Section */}
                <div className="mb-4">
                  <h4 className="border-bottom pb-2 mb-3">Description</h4>

                  <div className="row mb-3">
                    <div className="col-sm-12">
                    <textarea
                        className="form-control"
                        id="productDescription"
                        rows="5"
                        value={productDescription}
                        onChange={(event) => setProductDescription(event.target.value)}
                        style={{ minHeight: "170px" }}
                    ></textarea>
                      <button
                          type="button"
                          className="btn btn-info mt-2"
                          onClick={improveDescription}
                      >
                        ✨ Improve Description with AI
                      </button>
                    </div>
                  </div>
                </div>

                {/* Images Section */}
                <div className="mb-4">
                  <h4 className="border-bottom pb-2 mb-3">Product Images</h4>

                  <div className="row g-3">
                    {/* Front Image with AI Generation */}
                    <div className="col-12">
                      <div className="card p-3">
                        <h6 className="card-title">Front Image</h6>
                        <div className="row">
                          <div className="col-md-4">
                            <div className="position-relative">
                              <img
                                  src={frontImage}
                                  className="img-fluid rounded mb-2"
                                  alt="Front"
                                  style={{
                                    width: "100%",
                                    height: "250px",
                                    objectFit: "cover",
                                  }}
                              />
                              {frontImage && (
                                  <button
                                      type="button"
                                      className="btn btn-danger btn-sm position-absolute top-0 end-0 m-2"
                                      onClick={deleteFrontImage}
                                      title="Delete front image"
                                  >
                                    ×
                                  </button>
                              )}
                            </div>
                            <input
                                type="file"
                                className="form-control form-control-sm"
                                onChange={onFileChange1}
                            />
                          </div>

                          {/* AI Image Generation Section */}
                          <div className="col-md-8">
                            {!useAIImage && !aiGeneratedPreview && (
                                <div className="p-3 bg-light rounded border h-100 d-flex flex-column justify-content-center">
                                  <h6 className="mb-2">🤖 AI Model Image Generator</h6>
                                  <p className="small text-muted mb-3">
                                    Generate a professional model-wearing image from the current front image
                                  </p>
                                  <button
                                      type="button"
                                      className="btn btn-primary"
                                      onClick={handleGenerateAIImage}
                                      disabled={isGeneratingAI}
                                  >
                                    {isGeneratingAI ? (
                                        <>
                                    <span
                                        className="spinner-border spinner-border-sm me-2"
                                        role="status"
                                        aria-hidden="true"
                                    ></span>
                                          Generating AI Image...
                                        </>
                                    ) : (
                                        "✨ Generate AI Model Image"
                                    )}
                                  </button>
                                </div>
                            )}

                            {/* AI Preview & Approval */}
                            {aiGeneratedPreview && !useAIImage && (
                                <div className="p-3 bg-success bg-opacity-10 rounded border border-success">
                                  <h6 className="mb-2 text-success">✓ AI Model Image Generated</h6>
                                  <p className="small mb-2">
                                    Preview the AI-generated image and approve it to replace the front image
                                  </p>
                                  <img
                                      src={aiGeneratedPreview}
                                      alt="AI Generated"
                                      className="img-fluid rounded mb-3"
                                      style={{ maxHeight: "200px" }}
                                  />
                                  <div className="d-flex gap-2">
                                    <button
                                        type="button"
                                        className="btn btn-success btn-sm"
                                        onClick={handleApproveAIImage}
                                    >
                                      ✓ Approve & Use This Image
                                    </button>
                                    <button
                                        type="button"
                                        className="btn btn-outline-primary btn-sm"
                                        onClick={handleGenerateAIImage}
                                        disabled={isGeneratingAI}
                                    >
                                      🔄 Regenerate
                                    </button>
                                    <button
                                        type="button"
                                        className="btn btn-outline-danger btn-sm"
                                        onClick={handleRejectAIImage}
                                    >
                                      × Discard
                                    </button>
                                  </div>
                                </div>
                            )}

                            {/* AI Image Approved */}
                            {useAIImage && (
                                <div className="p-3 bg-primary bg-opacity-10 rounded border border-primary">
                                  <h6 className="mb-2 text-primary">✓ Using AI-Generated Model Image</h6>
                                  <img
                                      src={aiGeneratedPreview}
                                      alt="AI Generated - Approved"
                                      className="img-fluid rounded mb-2"
                                      style={{ maxHeight: "200px" }}
                                  />
                                  <p className="small mb-2">
                                    This AI-generated image will replace the front image when you save
                                  </p>
                                  <button
                                      type="button"
                                      className="btn btn-outline-danger btn-sm"
                                      onClick={handleRejectAIImage}
                                  >
                                    × Remove AI Image
                                  </button>
                                </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Other Images with Delete Buttons */}
                    <div className="col-md-4">
                      <div className="card h-100 p-3">
                        <h6 className="card-title">Left Image</h6>
                        <div className="position-relative">
                          <img
                              src={leftImage}
                              className="img-fluid rounded mb-2"
                              alt="Left"
                              style={{
                                width: "100%",
                                height: "200px",
                                objectFit: "cover",
                              }}
                          />
                          {leftImage && (
                              <button
                                  type="button"
                                  className="btn btn-danger btn-sm position-absolute top-0 end-0 m-2"
                                  onClick={deleteLeftImage}
                                  title="Delete left image"
                              >
                                ×
                              </button>
                          )}
                        </div>
                        <input
                            type="file"
                            className="form-control form-control-sm"
                            onChange={onFileChange2}
                        />
                      </div>
                    </div>

                    <div className="col-md-4">
                      <div className="card h-100 p-3">
                        <h6 className="card-title">Right Image</h6>
                        <div className="position-relative">
                          <img
                              src={rightImage}
                              className="img-fluid rounded mb-2"
                              alt="Right"
                              style={{
                                width: "100%",
                                height: "200px",
                                objectFit: "cover",
                              }}
                          />
                          {rightImage && (
                              <button
                                  type="button"
                                  className="btn btn-danger btn-sm position-absolute top-0 end-0 m-2"
                                  onClick={deleteRightImage}
                                  title="Delete right image"
                              >
                                ×
                              </button>
                          )}
                        </div>
                        <input
                            type="file"
                            className="form-control form-control-sm"
                            onChange={onFileChange3}
                        />
                      </div>
                    </div>

                    <div className="col-md-4">
                      <div className="card h-100 p-3">
                        <h6 className="card-title">Back Image</h6>
                        <div className="position-relative">
                          <img
                              src={backImage}
                              className="img-fluid rounded mb-2"
                              alt="Back"
                              style={{
                                width: "100%",
                                height: "200px",
                                objectFit: "cover",
                              }}
                          />
                          {backImage && (
                              <button
                                  type="button"
                                  className="btn btn-danger btn-sm position-absolute top-0 end-0 m-2"
                                  onClick={deleteBackImage}
                                  title="Delete back image"
                              >
                                ×
                              </button>
                          )}
                        </div>
                        <input
                            type="file"
                            className="form-control form-control-sm"
                            onChange={onFileChange4}
                        />
                      </div>
                    </div>
                  </div>
                </div>

                {/* Product Video Section */}
                {/* Product Video Section */}
                <div className="mt-4 pt-3 border-top">
                  <h4 className="border-bottom pb-2 mb-3">🎬 Product Video</h4>
                  <div className="card p-3">
                    {!productVideoUrl ? (
                        <div className="text-center py-3">
                          <p className="text-muted mb-3">
                            No video yet. Generate a cinematic product video from the front image.
                          </p>
                          <button
                              type="button"
                              className="btn btn-primary"
                              onClick={handleGenerateVideo}
                              disabled={isGeneratingVideo || (!frontImage && !aiGeneratedPreview)}
                          >
                            {isGeneratingVideo ? (
                                <>
                            <span
                                className="spinner-border spinner-border-sm me-2"
                                role="status"
                                aria-hidden="true"
                            ></span>
                                  Generating Video... (usually 5–8 min, keep this page open)
                                </>
                            ) : (
                                "🎬 Generate Product Video"
                            )}
                          </button>
                          {(!frontImage && !aiGeneratedPreview) && (
                              <p className="text-danger small mt-2">
                                Please upload or generate a front image first
                              </p>
                          )}
                        </div>
                    ) : (
                        <div className="row align-items-center">
                          <div className="col-md-8">
                            <video
                                key={productVideoUrl}
                                src={productVideoUrl}
                                controls
                                playsInline
                                loop
                                muted
                                style={{
                                  width: "100%",
                                  maxHeight: "320px",
                                  borderRadius: "8px",
                                  objectFit: "contain",
                                  background: "#000",
                                }}
                            />
                            {/* iPhone hint */}
                            <p className="small text-muted mt-1">
                              📱 On iPhone: long press the video to save
                            </p>
                          </div>
                          <div className="col-md-4 mt-3 mt-md-0 d-flex flex-column gap-2">
                            <a
                            href={productVideoUrl}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="btn btn-primary"
                            onClick={(e) => {
                            if (!/iPhone|iPad|iPod/i.test(navigator.userAgent)) {
                              e.preventDefault();
                              const link = document.createElement("a");
                              link.href = productVideoUrl;
                              link.download = "product-video.mp4";
                              document.body.appendChild(link);
                              link.click();
                              document.body.removeChild(link);
                            }
                          }}
                            >
                            ⬇ Download Video
                          </a>
                          <a
                          href={productVideoUrl}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="btn btn-outline-secondary"
                          >
                          ↗ Open in New Tab
                        </a>
                      <button
                      type="button"
                      className="btn btn-outline-primary"
                      onClick={handleGenerateVideo}
                       disabled={isGeneratingVideo}
                  >
                    {isGeneratingVideo ? (
                        <>
                                <span
                                    className="spinner-border spinner-border-sm me-2"
                                    role="status"
                                    aria-hidden="true"
                                ></span>
                          Regenerating...
                        </>
                    ) : (
                        "🔄 Regenerate Video"
                    )}
                  </button>
                  <button
                      type="button"
                      className="btn btn-outline-danger"
                      onClick={() => setProductVideoUrl("")}
                  >
                    × Remove Video
                  </button>
                </div>
            </div>
            )}
          </div>
        </div>
                {/* Action Buttons */}
                <div className="d-flex justify-content-between mt-4 pt-3 border-top">
                  <button
                      type="button"
                      onClick={handleBack}
                      className="btn btn-secondary btn-lg"
                  >
                    <ArrowBackIcon fontSize="small" /> Cancel
                  </button>
                  <button type="submit" className="btn btn-primary btn-lg px-5">
                    💾 Update Product
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </>
  );
}

export default ProductUpdatePage;